import { Component, Inject } from '@angular/core';
import { CanDisable, mixinDisabled } from '@angular/material/core';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MAT_LEGACY_DIALOG_DATA, MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacySnackBarModule, MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import {
  Countertop,
  CountertopMaterial,
  GShapedCountertop,
  GShapedCountertopSubtypeEnum,
  PShapedCountertop,
  PShapedCountertopSubtypeEnum,
  SimpleCountertop,
} from 'cloud-shared-lib';
import { ItemCardComponent } from '../../item-card/item-card.component';

export class CountertopTypeSelectDialogBase {}
export const _CountertopTypeSelectDialogMixinBase = mixinDisabled(CountertopTypeSelectDialogBase);

@Component({
  templateUrl: 'countertop-type-select-dialog.component.html',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['disabled'],
  standalone: true,
  imports: [ItemCardComponent, MatLegacyDialogModule, MatLegacyButtonModule, MatLegacySnackBarModule],
})
export class CountertopTypeSelectDialogComponent extends _CountertopTypeSelectDialogMixinBase implements CanDisable {
  pShapedTypes = PShapedCountertopSubtypeEnum;
  gShapedTypes = GShapedCountertopSubtypeEnum;

  countertop: Countertop;

  selected: ItemCardComponent;

  constructor(private snackBar: MatSnackBar, @Inject(MAT_LEGACY_DIALOG_DATA) private material: CountertopMaterial) {
    super();
  }

  selectPShapedType(type: PShapedCountertopSubtypeEnum): void {
    if (!this.material) {
      this.snackBar.open($localize`Выберите материал`);
      return;
    }

    this.countertop = new PShapedCountertop(this.material.width * 3, this.material.width * 2, this.material, type);

    this.countertop.length = this.countertop.lines[0].width * 3;
    this.countertop.width = this.countertop.lines[0].width * 2;
  }

  selectGShapedType(type: GShapedCountertopSubtypeEnum): void {
    if (!this.material) {
      this.snackBar.open($localize`Выберите материал`);
      return;
    }

    this.countertop = new GShapedCountertop(this.material.width * 3, this.material.width * 2, this.material, type);

    this.countertop.length = this.countertop.lines[0].width * 3;
    this.countertop.width = this.countertop.lines[0].width * 2;
  }

  selectSimpleType(): void {
    if (!this.material) {
      this.snackBar.open($localize`Выберите материал`);
      return;
    }

    this.countertop = new SimpleCountertop(this.material.width * 3, this.material.width, this.material);

    this.countertop.length = this.countertop.lines[0].width * 3;
  }
}
